import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "container lg:grid lg:grid-cols-12 lg:gap-8" }
const _hoisted_2 = { class: "-mx-8 h-fit bg-gray-200/60 pt-8 pb-32 lg:sticky lg:top-20 lg:col-span-5 lg:-ml-20 lg:mr-0 lg:px-20 lg:py-14" }
const _hoisted_3 = { class: "px-8 py-14 lg:p-0" }
const _hoisted_4 = { class: "mt-8 space-y-8" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "flex items-center" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = { class: "-mt-32 lg:col-span-7 lg:mt-32 lg:min-h-[calc(100vh-13rem)]" }
const _hoisted_9 = { class: "-mx-4 flex flex-col bg-white px-4 pt-14 lg:pt-0" }
const _hoisted_10 = ["target", "href"]
const _hoisted_11 = { class: "font-bold lg:text-xl" }
const _hoisted_12 = { class: "text-gray-400" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 1,
  class: "mx-1.5"
}
const _hoisted_15 = {
  key: 2,
  class: "mx-1.5"
}
const _hoisted_16 = {
  key: 3,
  class: "mx-1.5"
}
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "mx-1.5" }, "|", -1)
const _hoisted_18 = { class: "hidden border border-black p-3 group-hover:bg-black group-hover:text-white lg:block" }
const _hoisted_19 = {
  key: 0,
  class: "-mt-14 py-28 hyphens-auto lg:-mt-20 lg:bg-gray-200 lg:px-20"
}
const _hoisted_20 = { class: "break-words pb-4 lg:pb-7 lg:text-6xl" }
const _hoisted_21 = { class: "break-words text-gray-400" }
const _hoisted_22 = { ref: "observer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!
  const _component_biz_dropdown_group = _resolveComponent("biz-dropdown-group")!
  const _component_dropdown_item = _resolveComponent("dropdown-item")!
  const _component_biz_dropdown = _resolveComponent("biz-dropdown")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title", {
          total: _ctx.totalResults,
          place: 
                        _ctx.filters.find(x => x.key === 'country')?.selected
                            ? _ctx.filters.find(x => x.key === 'country').selected
                            : _ctx.preFilters.find(x => x.key === 'country')
                            ? _ctx.preFilters.find(x => x.key === 'country').value
                            : ''
                    ,
          area: 
                        _ctx.filters.find(x => x.key === 'jobCategory')?.selected
                            ? _ctx.filters.find(x => x.key === 'jobCategory').selected
                            : _ctx.preFilters.find(x => x.key === 'jobCategory')
                            ? _ctx.preFilters.find(x => x.key === 'jobCategory').value
                            : ''
                    
        }),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filters, (filter) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (filter.key === 'country')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 'filter-' + filter.key,
                    class: "flex flex-wrap pb-4"
                  }, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleInternational && _ctx.toggleInternational(...args))),
                      class: _normalizeClass(["flex max-w-full flex-initial cursor-pointer items-center px-5", 
                                    _ctx.international
                                        ? 'bg-black text-white'
                                        : 'bg-gray-350 text-gray-400'
                                ])
                    }, [
                      _createVNode(_component_biz_icon, {
                        class: "h-4 w-4 shrink-0 fill-current",
                        name: "earth-europe-light"
                      })
                    ], 2),
                    _createVNode(_component_biz_dropdown_group, {
                      contrast: !_ctx.international
                    }, {
                      title: _withCtx(() => [
                        _createTextVNode(_toDisplayString(filter.selected ? filter.selected : filter.label), 1)
                      ]),
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.allValues, (country, countryIndex) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: 'country' + countryIndex
                            }, [
                              (country.name !== 'undefined')
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 0,
                                    class: _normalizeClass(["flex justify-between px-6 py-4 hover:bg-gray-200 hover:text-gray-500", 
                                                filter.selected == country.name
                                                    ? 'text-black'
                                                    : 'text-gray-400'
                                            ]),
                                    onClick: ($event: any) => (_ctx.toogleCountry(country, filter))
                                  }, [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createElementVNode("div", {
                                        class: _normalizeClass(["mr-2 h-4 w-4 border-2 border-current", [
                                                        filter.selected == country.name
                                                            ? 'bg-black'
                                                            : 'bg-transparent'
                                                    ]])
                                      }, [
                                        _createVNode(_component_biz_icon, {
                                          class: "h-3 w-3 shrink-0 fill-white",
                                          name: "checked"
                                        })
                                      ], 2),
                                      _createElementVNode("span", null, _toDisplayString(country.name), 1)
                                    ])
                                  ], 10, _hoisted_5))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["contrast"])
                  ]))
                : (_openBlock(), _createElementBlock("div", {
                    key: 'd-filter-' + filter.key
                  }, [
                    _createVNode(_component_biz_dropdown, {
                      title: filter.label,
                      onSelect: event => _ctx.toogleFilter(event, filter),
                      ref_for: true,
                      ref: filter.label
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.allValues, (value, index) => {
                          return (_openBlock(), _createBlock(_component_dropdown_item, {
                            key: filter.key + index,
                            disabled: !value.haveResults,
                            title: value.name,
                            value: value.name
                          }, null, 8, ["disabled", "title", "value"]))
                        }), 128))
                      ]),
                      _: 2
                    }, 1032, ["title", "onSelect"])
                  ]))
            ], 64))
          }), 256)),
          (_ctx.searchValueActive && _ctx.searchValueActive.key)
            ? (_openBlock(), _createElementBlock("div", {
                key: "search-filter",
                class: _normalizeClass(["relative flex w-full items-center", [_ctx.searchValue ? 'text-gray-500' : 'text-gray-400']])
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["absolute origin-left transition-transform", [
                                {
                                    '-translate-y-full scale-75': _ctx.searchValue.length
                                }
                            ]])
                }, _toDisplayString(_ctx.searchValueActive.label), 3),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchValue) = $event)),
                  placeholder: _ctx.searchValueActive.label,
                  class: "form-input"
                }, null, 8, _hoisted_7), [
                  [_vModelText, _ctx.searchValue]
                ]),
                _createVNode(_component_biz_icon, {
                  class: "absolute right-0 -z-10 ml-4 h-4 w-4 shrink-0 fill-current",
                  name: "search"
                })
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.hasSearchPoints)
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.resetFilters && _ctx.resetFilters(...args))),
                class: "button button-text ml-auto mt-8 block pb-0 opacity-50 transition-opacity hover:opacity-100"
              }, _toDisplayString(_ctx.resetFiltersText), 1))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.careers, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "border-b border-black/30"
          }, [
            _createElementVNode("a", {
              target: item.detailsUrlTarget,
              href: item.detailsUrl,
              class: "min-h-28 group flex gap-4 py-7 lg:items-center lg:justify-between lg:py-10"
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_12, [
                  _createTextVNode(_toDisplayString(item.city) + " ", 1),
                  (item.city && item.country)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_13, ", "))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.country) + " ", 1),
                  (
                                        (item.company || item.jobType || item.jobCategory) &&
                                        (item.city || item.country)
                                    )
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "|"))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.company) + " ", 1),
                  (item.company && (item.jobType || item.jobCategory))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, " | "))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.jobType) + " ", 1),
                  (item.jobType && item.jobCategory)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, "|"))
                    : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(item.jobCategory) + " ", 1),
                  _hoisted_17,
                  _createTextVNode(" " + _toDisplayString(item.jobId), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_biz_icon, {
                  class: "h-3.5 w-3.5 shrink-0 fill-current",
                  name: "chevron-right"
                })
              ])
            ], 8, _hoisted_10)
          ]))
        }), 128)),
        (!_ctx.careers.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.noJobsTitle), 1),
              _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.noJobsText), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_22, null, 512),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
      : _createCommentVNode("", true)
  ]))
}